export default "__VITE_ASSET__BGU7L5UD__"